const LOGIN_AUDIT_PENDING_KEY = 'graphium.loginAuditPending';

/**
 * Marks that the next startup call should record an audit event for the org being entered.
 *
 * The server writes one org-side `USER_LOGGED_IN` per marked startup call, so this marker has to mean
 * "the user just entered an org" and nothing else. Two places set it: the login container, which
 * renders only while nobody is authenticated, and a genuine org switch.
 *
 * It deliberately does not key off AuthStore's `'login'` state. `handleAuthentication` sets that on
 * every page load, a refresh included, so using it would write a login event per reload.
 *
 * Session storage rather than a store field because the login case has to survive a full redirect out
 * to Auth0 and back, which discards everything held in memory.
 */
export function markLoginAuditPending() {
    try {
        sessionStorage.setItem(LOGIN_AUDIT_PENDING_KEY, 'true');
    } catch (e) {
        // Best effort. A browser with session storage blocked loses an audit event, not the login.
    }
}

/**
 * Reads the marker and clears it.
 *
 * One-shot on purpose: startup runs again on every refresh, and leaving the marker set would record
 * another login each time.
 */
export function consumeLoginAuditPending() {
    try {
        const isPending = sessionStorage.getItem(LOGIN_AUDIT_PENDING_KEY) === 'true';
        sessionStorage.removeItem(LOGIN_AUDIT_PENDING_KEY);
        return isPending;
    } catch (e) {
        return false;
    }
}
